// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Qzgw","inner":"styles_inner__1SEPt","right":"styles_right__2lBXv","close":"styles_close__30WUQ","footer":"styles_footer__3wLUC"};